module.exports = __webpack_public_path__ + "img/解决方案_定制_白.0c53858e.svg";